import React, { useContext, useEffect, useState } from 'react'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'

export default function Wizard({ sections, onNavigate, onChangeValues }) {
    if (!sections) return <div>No Components</div>
    return (
        <WizardProvider sections={sections} onNavigate={onNavigate} onChangeValues={onChangeValues}>
            <div className="Wizard top-center position-relative m-3">
                <WizardHead subsection={''} title={''} description={''} />
                <WizardBody />
                <WizardTail />
            </div>
        </WizardProvider>
    )
}

export const WizardContext = React.createContext()
const WizardProvider = ({ sections, onNavigate, children, onChangeValues }) => {
    const { showError } = useContext(CommonFunctionsContext)
    const [title, setTitle] = useState()
    const [description, setDescription] = useState()
    const [values, setValues] = useState({})
    const [state, setState] = useState({
        navigation: [],
        title: '',
        description: '',
        step: -1
    })

    useEffect(() => { if (onChangeValues) onChangeValues(values) }, [values])

    const _handleSetStep = (step, options) => {
        /**
         * Back Option
         */
        if (options) {
            if (options.previousStep)
                setState({ ...state, navigation: [{ text: 'Done', type: 'Done', step: options.previousStep }] })
        }

        if (onNavigate) {
            if (onNavigate(state.step, step))
                setState({ ...state, step: step })
        }
        else
            setState({ ...state, step: step })
    }
    const _handleSetValues = (val) => setValues({ ...values, ...val })

    // Process component
    const _renderBody = () => {
        return (
            {
                ...sections[(state.step + 1)],
                props: {
                    ...sections[(state.step + 1)].props,
                    title: (t) => setTitle(t),
                    description: (t) => setDescription(t),
                    navigation: (t) => setState({ ...state, navigation: [...t] }),
                    navigator: {},
                    errors: (e) => showError(e),
                    setValue: _handleSetValues,
                    values: values,
                }
            })
    }

    // Navigate to section based on name
    // name to be set as component props
    const _handleGoToSection = (s) =>
        _handleSetStep(sections.indexOf(sections.find(z => z.props.name === s)) - 1)

    return <WizardContext.Provider value={{
        navigation: state.navigation,
        setStep: (s, o) => _handleSetStep(s, o),
        gotoSection: _handleGoToSection,
        step: state.step,
        values: values,
        setValues: (v) => _handleSetValues(v),
        body: () => _renderBody(),
        title,
        description,
        showError,
        state
    }}>{children}</WizardContext.Provider>
}
const WizardHead = ({ subsection }) => {
    const { description, title } = useContext(WizardContext)
    return (<div className="head"><h1>{!subsection ? title : ''}</h1>
        <p>{!subsection ? description : ''}</p>
    </div>)
}
const WizardBody = ({ subsection, title, description }) => {
    const { body } = useContext(WizardContext)
    return (<div className="body" style={{ overflow: subsection ? 'visible' : 'auto' }}>
        <div
            className=".section d-flex flex-column align-items-stretch h-100 w-100">
            {body()}
        </div>
    </div>)
}
const WizardTail = () => {


    const { gotoSection, navigation, setStep, step, values, showError } = useContext(WizardContext)

    return (<div className="tail">
        {
            navigation.map((n) => {
                if (n.type === 'Next')
                    return <button
                        key={n.text}
                        onClick={async (e) => {
                            if (n.action) {
                                try {
                                    await n.action()
                                        .catch(() => {
                                            showError(e.message)
                                            return
                                        })
                                } catch (e) {
                                    return
                                }
                            }
                            setStep(step + 1)
                        }} className="btn ng-buttons">{n.text}</button>
                else if (n.type === 'Back')
                    return <button
                        key={n.text}
                        onClick={async (e) => {
                            if (n.action) {
                                await n.action().catch((e) => showError(e.message))
                            }
                            if (values.action) {
                                setStep(values.action.from)
                            } else {
                                setStep(step - 1)
                            }
                        }} className="btn ng-buttons">{n.text}</button>
                else if (n.type === 'Action')
                    return <button
                        key={n.text}
                        onClick={async (e) => {
                            if (Object.keys(n).includes('action'))
                                await n.action()
                                    .catch((e) => showError(e.message))
                        }} className="btn ng-buttons">{n.text}</button>
                else if (n.type === 'Goto')
                    return <button
                        key={n.text}
                        onClick={e => gotoSection(n.section)
                        } className="btn ng-buttons">{n.text}</button>
                else if (n.type === 'Done')
                    return <button
                        key={n.text}
                        onClick={async (e) => {
                            if (n.action)
                                await n.action()
                                    .catch((e) => showError(e.message))
                            setStep(-1)
                        }} className="btn ng-buttons">{n.text}</button>
                else if (n.type === 'Step')
                    return <button
                        key={n.text}
                        onClick={async (e) => {
                            if (n.action)
                                await n.action()
                                    .catch((e) => showError(e.message))
                            setStep(n.step)
                        }} className="btn ng-buttons">{n.text}</button>
                else return undefined
            })
        }
    </div>)
}